var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRadioActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49967 3.66683C5.65967 3.66683 4.16634 5.16016 4.16634 7.00016C4.16634 8.84016 5.65967 10.3335 7.49967 10.3335C9.33967 10.3335 10.833 8.84016 10.833 7.00016C10.833 5.16016 9.33967 3.66683 7.49967 3.66683ZM7.49967 0.333496C3.81967 0.333496 0.833008 3.32016 0.833008 7.00016C0.833008 10.6802 3.81967 13.6668 7.49967 13.6668C11.1797 13.6668 14.1663 10.6802 14.1663 7.00016C14.1663 3.32016 11.1797 0.333496 7.49967 0.333496ZM7.49967 12.3335C4.55301 12.3335 2.16634 9.94683 2.16634 7.00016C2.16634 4.0535 4.55301 1.66683 7.49967 1.66683C10.4463 1.66683 12.833 4.0535 12.833 7.00016C12.833 9.94683 10.4463 12.3335 7.49967 12.3335Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioActive);
export default __webpack_public_path__ + "static/media/radio_active.a0543c09.svg";
export { ForwardRef as ReactComponent };